import React from 'react';
import { Button, withStyles } from '@material-ui/core';
import SaveButtonWithoutIcon from './SaveButtonWithoutIcon';
import { Link } from 'react-router-dom';
import StyledToolbar from './StyledToolbar';
import ToolbarButtonsStyles from './ToolbarButtonsStyles';

const CustomToolbar = props => {
  const { classes, cancelUrl, onCancel, isLoading = false, customSaveBtnLabel, ...rest } = props;
  const isEdit = !!props.record.id;
  const saveBtnLabel = customSaveBtnLabel || (isEdit ? 'save' : 'create');
  return (
    <StyledToolbar {...rest}>
      {onCancel && !cancelUrl ?
        <Button
          className={`${classes.button} ${classes.cancelButton}`}
          onClick={onCancel}
        >
          cancel
        </Button>
        :
        <Button
          className={`${classes.button} ${classes.cancelButton}`}
          component={Link}
          to={cancelUrl}
        >
          cancel
        </Button>
      }
      <SaveButtonWithoutIcon
        color="secondary"
        className={`${classes.button} ${classes.saveButton}`}
        label={saveBtnLabel}
        submitOnEnter={true}
        disabled={rest.pristine || rest.invalid || rest.saving || isLoading}
      />
    </StyledToolbar>
  );
};

CustomToolbar.defaultProps = {
  transform: data => data,
};

export default withStyles(ToolbarButtonsStyles)(CustomToolbar);
